import { isDefined } from './is';

export const isEveryElementInArray = (arrayA: string[] | null | undefined, arrayB: string[] | null | undefined) => {
  if (!isDefined(arrayA) || !isDefined(arrayB)) {
    return false;
  }

  return arrayA.every(element => arrayB.includes(element));
};
